<template>
  <section class="mapContent posire" :class="{ hadKeywordList: listVisible }">
    <baidu-map
        class="map"
        :scroll-wheel-zoom="true"
        :center="center"
        :zoom="zoom"
        @ready="renderMap"
        @click="handleMapClick"
        :map-click="false"
    >
      <bm-view class="map" />
      <bm-geolocation
          anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
          :showAddressBar="true"
          :autoLocation="true"
      />
      <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT" />
    </baidu-map>
  </section>
</template>

<script>
export default {
  data () {
    return {
      // 搜索结果数组
      searchResultList: [],
      currentSelectTitle: '',
      listVisible: false,
      searchTimer: null,
      searchAddr: '',
      BMap: null,
      map: null,
      dialogVisible: false,
      center: { lng: 0, lat: 0 },
      zoom: 3,
      pointDescVisible: false,
      markerPoint: null,
      markerPointAddress: '',
      // 下面是订单录入需要用到的参数
      markerPointAddressDetail: null,

      districtLoading: 0,
      blist: [],
      otherFormData: {
        fenceShapeType: '', // 围栏类型
        radius: '', // 圆形围栏的半径
        area: '', // 行政区域围栏的行政区域名称
      },
      // 圆形围栏参数
      circlePath: {
        center: {},
        // radius: null,
      },
      // 多边形围栏参数
      polygonPath: [],
      // 行政区域围栏参数
      areaName: '',
      isModifyPolygon: false,
    };
  },
  methods: {
    renderMap ({BMap, map}) {
      this.BMap = BMap;
      this.map = map;
      this.markerPoint = this.center;
      this.center.lng = 116.404;
      this.center.lat = 39.915;
      this.zoom = 15;
    },
    // e 是 经纬度
    handleMapClick (e) {
      if (this.$route.query.type === 'view') {
        return;
      }
      if (e && e.point) {
        this.markerPoint = e.point;
        let _this = this;
        if (this.otherFormData.fenceShapeType) {
          // 圆形围栏
          if (this.otherFormData.fenceShapeType === '1') {
            this.$emit('centerMarker', e.point);
            var circle = new this.BMap.Circle({...e.point}, _this.otherFormData.radius || 1000, {
              strokeColor: 'blue',
              strokeWeight: 2,
              strokeOpacity: 0.5,
            });
            this.map.clearOverlays();
            this.map.addOverlay(circle);
            this.$emit('draw', true);
          } else if (this.otherFormData.fenceShapeType === '2') {
            if (this.isModifyPolygon) {
              this.isModifyPolygon = false;
              return;
            }
            // 绘制面
            var polygon = new this.BMap.Polygon([
              new this.BMap.Point(e.point.lng, e.point.lat + 0.007),
              new this.BMap.Point(e.point.lng - 0.009, e.point.lat - 0.006),
              new this.BMap.Point(e.point.lng + 0.009, e.point.lat - 0.006),
            ], {
              strokeColor: 'blue',
              strokeWeight: 2,
              strokeOpacity: 0.5,
              enableEditing: true,
            });
            this.map.clearOverlays();
            this.map.addOverlay(polygon);
            this.$emit('draw', true);
            _this.polygonPath = polygon.getPath();
            polygon.addEventListener('lineupdate', function (e) {
              _this.polygonPath = e.target.getPath();
              _this.isModifyPolygon = true;
            });
          }
        }

      } else {
        // this.getAddress();
      }
    },
    fenceShape (val, data, pts) {
      this.otherFormData.fenceShapeType = val;
      let _this = this;
      this.map.clearOverlays();
      this.$emit('draw', false);
      if (val === '1' && data) {
        this.otherFormData.radius = data;
        if (pts && this.otherFormData.radius) {
          _this.center = pts;
          var circle = new this.BMap.Circle({...pts}, _this.otherFormData.radius || 1000, {
            strokeColor: 'blue',
            strokeWeight: 2,
            strokeOpacity: 0.5,
            // enableEditing: true,
          });
          this.map.addOverlay(circle);
          this.$emit('draw', pts !== null);
          circle.addEventListener('lineupdate', function (e) {
            _this.circlePath = e.target.getCenter();// 返回圆形覆盖物的中心点
            _this.circlePath.radius = e.target.getRadius();// 返回圆形覆盖物的半径
          });
        }

      } else if (val === '2') {
        // 绘制面
        var polygon = new this.BMap.Polygon(pts, {
          strokeColor: 'blue',
          strokeWeight: 2,
          strokeOpacity: 0.5,
          enableEditing: true,
        });
        this.map.addOverlay(polygon);
        this.$emit('draw', pts && pts.length > 0);
        _this.polygonPath = polygon.getPath();
        let points = [];
        pts.map((p) => points.push({lat: p.lat, lng: p.lng}));
        this.map.setViewport(points); // 调整视野
        polygon.addEventListener('lineupdate', function (e) {
          _this.polygonPath = e.target.getPath();
          _this.isModifyPolygon = true;
        });
      } else if (val === '3') {
        this.otherFormData.area = data;
        this.areaName = data;


        this.addDistrict(data);
        this.$emit('draw', this.areaName != null && this.areaName !== '');
      }
    },
    addDistrict (districtName) { // 加行政区域的屏蔽层

      // 使用计数器控制加载过程
      this.districtLoading++;
      let _this = this;
      var bdary = new this.BMap.Boundary();

      bdary.get(districtName, function (rs) {
        // 获取行政区域

        var count = rs.boundaries.length; // 行政区域的点数量
        if (districtName && count === 0) {
          _this.$message({
            type: 'error',
            message: '请选择正确的行政区域！',
          });
          return;
        }
        for (var i = 0; i < count; i++) {
          _this.blist.push({
            points: rs.boundaries[i],
          });
        }
        // 加载完成区域点后计数器-1
        _this.districtLoading--;
        if (_this.districtLoading === 0) {
          // 全加载完成后画端点
          _this.drawBoundary();
        }
      });
    },
    drawBoundary () { // 反选行政区
      // 包含所有区域的点数组
      var pointArray = [];

      var pNW = {lat: 59.0, lng: 73.0};
      var pNE = {lat: 59.0, lng: 136.0};
      var pSE = {lat: 3.0, lng: 136.0};
      var pSW = {lat: 3.0, lng: 73.0};

      // 向数组中添加一次闭合多边形，并将西北角再加
      var pArray = [];
      pArray.push(pNW);
      pArray.push(pSW);
      pArray.push(pSE);
      pArray.push(pNE);
      pArray.push(pNW);

      this.map.clearOverlays(); // 先清除掉地图的覆盖物
      const plys = [];
      for (var i = 0;i < this.blist.length;i++) { // 循环添加各闭合区域
        // 添加多边形层并显示
        var ply = new this.BMap.Polygon(this.blist[i].points, {
          strokeWeight: 2,
          strokeColor: 'blue',
          fillOpacity: 1,
          fillColor: '#5e8bff',
          enableMassClear: true,
        });
        this.map.addOverlay(ply);
        plys.push(ply);
        // 将点增加到视野范围内
        var path = ply.getPath();
        pointArray = pointArray.concat(path);
        pArray = pArray.concat(path);
        pArray.push(pArray[0]);

        var pts = plys[0].getPath();
        for (var i = 1;i < plys.length;i++) {
          pts = pts.concat(plys[i].getPath());
        }
        this.map.setViewport(pts); // 调整视野
      }
      this.blist = []; // 把上一个获取的行政区域地址信息清除
    },
  },
};
</script>

<style scoped lang="scss">
.searchList {
  width: 240px;
  position: absolute;
  top: 55px;
  left: 20px;
}
.searchMapInputBox {
  padding: 20px;
  .searchInput {
    width: 400px;
    margin-right: 16px;
  }
}
.mapContent {
  .map {
    width: 100%;
    height: 821px;
  }
  .searchList {
    ::v-deep ol {
      height: 474px;
      overflow-y: auto;
    }
  }
}
.hadKeywordList {
  padding-left: 264px;
}

.BMap_noprint anchorTL{
  inset: 30px auto auto 450px!important;
}
</style>
